import React from 'react';
import inRange from 'lodash.inrange';

export const anonymousUserData = { age: undefined, clientType: 'Anonymous', confidenceScoreResult: undefined, showMeter: false, lowerLimit: undefined, upperLimit: undefined };

export const tRoweFormatted =  <span className={'trpNoWrap'}>T. Rowe Price</span>;

export const RICPhoneNumbers = {
    serviceErrorNumber: `1-888-358-8490`,
};

export const probBarContent = [
    {
        range: 'Below',
        text: 'Want to be ready for retirement? We can help you plan and save, no matter what your timeline.',

    },
    {
        range: 'In',
        text: 'Want a more secure financial future? We can help you achieve your retirement goals.'
    },
    {
        range: 'Above',
        text: 'Congratulations! We can help you stay on track and confidently approach your retirement goals.'
    },
    {
        range: 'none',
        text: ''
    }
];

export const rasCardContent = {
    title: `Get on track. Retirement Advisory Service™ can help.`,
    content: `More than a plan, a guided path to help you stay on track. Get a personalized financial plan with no cost or commitment. 
    Enjoy advisor support and powerful digital tools when you enroll in the discretionary service (min. $250,000).`
}

const randomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const randomBoolean = Math.random() >= 0.5;

export const randomAge = randomNumber(22, 100);

export const randomSuccessRange = randomNumber(0, 100);


export const filterContentOnScore = (list, range, lowerLimit, upperLimit) => {
        if (inRange(range, lowerLimit)) {
            return list[0];
        }
        if (inRange(range, lowerLimit, upperLimit + 1)) {
            return list[1];
        }
        if (inRange(range, upperLimit, 101)) {
            return list[2];
        }
        return list[3];
};

export const userTypes = {
    'ANONYMOUS' : 'Anonymous',
    'GUEST': 'Guest',
    'CLIENT': 'Client'
};
